'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanSelection = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _isMobile = require('helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _markdown = require('helpers/markdown');

var _optimizely = require('helpers/optimizely');

var _verify = require('helpers/verify');

var _CardSelection = require('components/CardSelection');

var _LocationSelector = require('components/CmsPage/modules/LocationSelector/LocationSelector');

var _planTypes = require('constants/plan-types');

var _localStorage = require('redux/saga/helpers/local-storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Nike-specific methods are a temporary hack to enable
// Nike Plus Unlock card decorations in full-fare pricing pages, before
// we rework pricing pages to handle contextual promotions.
var NIKEFIVE = 'nikefive';
var NIKETEN = 'niketen';

var PlanSelection = exports.PlanSelection = function (_Component) {
  (0, _inherits3.default)(PlanSelection, _Component);

  function PlanSelection(props) {
    (0, _classCallCheck3.default)(this, PlanSelection);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PlanSelection.__proto__ || (0, _getPrototypeOf2.default)(PlanSelection)).call(this, props));

    _this2.handleSelectPlanClick = _this2.handleSelectPlanClick.bind(_this2);
    _this2.state = {
      selectedItemId: null,
      selectedItemType: null
    };
    return _this2;
  }

  (0, _createClass3.default)(PlanSelection, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.resetCardSelectionState(this.props.cards);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          cards = _props.cards,
          plansModuleConfig = _props.plansModuleConfig;


      if (nextProps.plansModuleConfig !== plansModuleConfig) {
        this.props.loadCardData(nextProps.plansModuleConfig);
      }

      if ((0, _isMobile2.default)() && nextProps.cards !== cards) {
        this.resetCardSelectionState(nextProps.cards);
      }
    }
  }, {
    key: 'onDwell',
    value: function onDwell() {
      (0, _optimizely.trackOptimizelyEvent)('view_plans');
    }
  }, {
    key: 'getCpOptimize',
    value: function getCpOptimize() {
      try {
        return this.props.isClient ? (0, _localStorage.readSessionStorage)('cpOptimize') : null;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: 'decorateNikePlusCards',
    value: function decorateNikePlusCards(cards) {
      var _NIKEFIVE$NIKETEN$get;

      var decorateIndex = (_NIKEFIVE$NIKETEN$get = {}, (0, _defineProperty3.default)(_NIKEFIVE$NIKETEN$get, NIKEFIVE, 1), (0, _defineProperty3.default)(_NIKEFIVE$NIKETEN$get, NIKETEN, 2), _NIKEFIVE$NIKETEN$get)[this.getCpOptimize()];

      var targetCard = cards[decorateIndex];

      if (!targetCard || targetCard.isNikePlusDecorated) {
        return cards;
      }

      var planPrice = targetCard.callout.replace(/\*/g, '');
      cards[decorateIndex] = (0, _extends3.default)({}, targetCard, {
        callout: '$*0*',
        calloutNote: '~~' + planPrice + '~~ first month',
        isNikePlusDecorated: true,
        tag: 'NikePlus Unlock'
      });

      // When we SSR, we don't have sessionStorage available.
      // So the first render renders without the NikePlus decoration,
      // and the client-side render would otherwise be cached.
      // This only executes once, since we don't re-decorate cards.
      (0, _markdown.resetMarkdownCache)();

      return cards;
    }
  }, {
    key: 'trackNikePlus',
    value: function trackNikePlus() {
      var _NIKEFIVE$NIKETEN$get2;

      var classCount = (_NIKEFIVE$NIKETEN$get2 = {}, (0, _defineProperty3.default)(_NIKEFIVE$NIKETEN$get2, NIKEFIVE, 5), (0, _defineProperty3.default)(_NIKEFIVE$NIKETEN$get2, NIKETEN, 10), _NIKEFIVE$NIKETEN$get2)[this.getCpOptimize()];

      (0, _optimizely.trackOptimizelyEvent)('NikePlus Unlock ' + classCount + '-Class');
    }
  }, {
    key: 'isNikePlusUnlock',
    value: function isNikePlusUnlock() {
      var cards = this.props.cards || [];
      return cards.length === 3 && cards.every(function (card) {
        return card.type === _planTypes.PLAN;
      }) && [NIKEFIVE, NIKETEN].includes(this.getCpOptimize());
    }
  }, {
    key: 'resetCardSelectionState',
    value: function resetCardSelectionState(cards) {
      this.setState({
        selectedItemId: !(0, _verify.isEmpty)(cards) ? cards[0].itemId : 0,
        selectedItemType: !(0, _verify.isEmpty)(cards) ? cards[0].type : 0
      });
    }
  }, {
    key: 'handleSelectPlanClick',
    value: function handleSelectPlanClick() {
      var _state = this.state,
          selectedItemId = _state.selectedItemId,
          selectedItemType = _state.selectedItemType;

      this.props.selectPlan(selectedItemType, selectedItemId);
    }
  }, {
    key: 'handleCardClick',
    value: function handleCardClick(itemType, itemId, isNikePlus) {
      if ((0, _isMobile2.default)()) {
        this.setState({
          selectedItemId: itemId,
          selectedItemType: itemType
        });
      } else {
        this.props.selectPlan(itemType, itemId);
      }

      if (isNikePlus) {
        this.trackNikePlus();
      }
    }
  }, {
    key: 'renderCards',
    value: function renderCards() {
      var _this = this;

      var cards = this.props.cards || [];

      return (this.isNikePlusUnlock() ? this.decorateNikePlusCards(cards) : cards).map(function (card) {
        return _react2.default.createElement(_CardSelection.CalloutCard, {
          callout: (0, _markdown.renderMarkdown)(card.callout, 'card_callout_' + card.type + '_' + card.itemId),
          calloutNote: (0, _markdown.renderMarkdown)(card.calloutNote, 'card_calloutNote_' + card.type + '_' + card.itemId),
          ctaCopy: card.cta,
          details: (0, _markdown.renderMarkdown)(card.details, 'card_details_' + card.type + '_' + card.itemId),
          key: card.itemId,
          onClick: function onClick() {
            return _this.handleCardClick(card.type, card.itemId, card.isNikePlusDecorated);
          },
          selected: card.itemId === _this.state.selectedItemId,
          tag: (0, _markdown.renderMarkdown)(card.tag, 'card_tag_' + card.type + '_' + card.itemId)
        });
      });
    }
  }, {
    key: 'renderCta',
    value: function renderCta() {
      return _react2.default.createElement(
        'button',
        {
          className: 'bt bt--primary bt--lg plan-selection__cta',
          onClick: this.handleSelectPlanClick
        },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'plan-selection.card.cta.select-plan',
          defaultMessage: 'Select plan'
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          cards = _props2.cards,
          creditsPerClassAverage = _props2.creditsPerClassAverage,
          disclaimer = _props2.disclaimer,
          msaSelectorLeadin = _props2.msaSelectorLeadin,
          subtitle = _props2.subtitle,
          subtitleStyle = _props2.subtitleStyle,
          title = _props2.title;


      if ((0, _verify.isEmpty)(cards)) {
        return false;
      }

      return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
          'div',
          { className: 'pricing color-background-light' },
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)('pricing__subtitle', 'pricing__subtitle--' + subtitleStyle, {
                'hidden md-block': subtitleStyle === 'subtle'
              })
            },
            subtitle
          ),
          _react2.default.createElement(
            'h2',
            { className: 'pricing__header' },
            title
          ),
          _react2.default.createElement(
            'div',
            { className: 'pricing__location-input pb++' },
            _react2.default.createElement(
              'div',
              { className: 'pricing__location-input__location' },
              _react2.default.createElement(_LocationSelector.LocationSelector, { label: msaSelectorLeadin })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'pricing__plans plan-selection' },
          this.renderCards(),
          this.renderCta()
        ),
        disclaimer && _react2.default.createElement(
          'p',
          { className: 'pricing__disclaimer text--center' },
          disclaimer
        ),
        !disclaimer && (0, _verify.isPresent)(creditsPerClassAverage) && _react2.default.createElement(
          'p',
          { className: 'pricing__disclaimer text--center' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'plan-selection.disclaimer.average-credits-per-class',
            defaultMessage: 'The average class in your area costs {creditsPerClassAverage, plural, one {# credit} other {# credits}}.',
            values: { creditsPerClassAverage: creditsPerClassAverage }
          })
        )
      );
    }
  }]);
  return PlanSelection;
}(_react.Component);

PlanSelection.propTypes = {
  cards: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    callout: _propTypes2.default.string.isRequired,
    calloutNote: _propTypes2.default.string.isRequired,
    cta: _propTypes2.default.string.isRequired,
    details: _propTypes2.default.string,
    itemId: _propTypes2.default.number,
    tag: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['plan', 'offer'])
  })),
  creditsPerClassAverage: _propTypes2.default.number,
  disclaimer: _propTypes2.default.string,
  isClient: _propTypes2.default.bool.isRequired,
  msaSelectorLeadin: _propTypes2.default.string,
  plansModuleConfig: _propTypes2.default.object,
  selectPlan: _propTypes2.default.func.isRequired,
  loadCardData: _propTypes2.default.func.isRequired,
  subtitle: _propTypes2.default.string,
  subtitleStyle: _propTypes2.default.oneOf(['subtle', 'loud']),
  title: _propTypes2.default.string.isRequired
};